module.exports = __webpack_public_path__ + "images/fdadaa7137b79682ba1304c720937b11.png";